<template>
  <section aria-label="Newsletter">
    <div class="newsletter">
      <h2 class="center xxl">Newsletter abonnieren</h2>
      <p class="tagline">
        Du möchtest auf dem Laufenden bleiben?<br />Dann abonniere jetzt den
        <strong>bayernwide Newsletter</strong>!
      </p>
      <p>
        <a href="https://digital-vereint.de/newsletter" target="_blank"
          >digital-vereint.de/newsletter</a
        >
      </p>
      <img
        class="qr-code"
        src="@/assets/img/qr-code-digital-vereint-newsletter.png"
        alt=""
      />
      <div class="logos">
        <div>
          <a href="https://lagfa-bayern.de" target="_blank"
            ><img
              src="@/assets/img/lagfa_logo.svg"
              alt="Zur Website der lagfa bayern e.V. (öffnet in neuem Tab)"
          /></a>
        </div>
        <div>
          <a href="https://www.sicher-im-netz.de/" target="_blank"
            ><img
              src="@/assets/img/dsin_logo.svg"
              alt="Zur Website von Deutschland sicher im Netz (öffnet in neuem Tab)"
          /></a>
        </div>
        <div>
          <a href="https://www.stmd.bayern.de/" target="_blank"
            ><img
              src="@/assets/img/StMD_RGB_Verbundlogo_Farbig_oS_Foerder_zuschnitt.png"
              alt="Zur Website des Staatsministerium für Digitales (öffnet in neuem Tab)"
          /></a>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@import "src/assets/scss/colors";
@import "src/assets/scss/layout";

.newsletter {
  .tagline {
    margin-bottom: 1em;
  }

  text-align: center;

  .qr-code {
    display: block;
    width: 280px;
    max-width: 50%;
    margin: 1em auto 0;
  }

  .logo-title {
    font-size: 17px;
    display: block;
  }

  a {
    font-size: 1.5em;
    font-weight: bold;
    color: $color-secondary-400;
    text-decoration: underline;
    text-decoration-color: $color-primary-400;
  }

  .logos {
    display: flex;
    flex-flow: wrap;
    align-items: center;
    justify-content: center;
    padding-top: 2em;

    div {
      flex: 0 0 33.33%;
      padding: 2em 0;
      width: fit-content;
      img {
        height: 2.125em;
      }

      a:focus-visible {
        display: inline-block;
        background: none;
        outline: $outline;
      }
    }
  }

  @media screen and (max-width: 1280px) {
    .logos {
      div {
        .logo-title {
          font-size: 14px;
        }
        img {
          height: 1.5em;
        }
      }
    }
  }

  @media screen and (max-width: 920px) {
    .logos {
      div {
        flex: 0 0 100%;
        padding: 1em 0;

        .logo-title {
          font-size: 16px;
        }

        img {
          height: 2.5em;
        }

        &:nth-child(3) {
          img {
            height: 2em;
          }
        }
      }
    }
  }

  @media screen and (max-width: 500px) {
    .logos {
      div {
        .logo-title {
          font-size: 12px;
        }

        img {
          height: 2em;
        }

        &:nth-child(3) {
          img {
            height: 1.5em;
          }
        }
      }
    }
  }
}
</style>
